
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Article } from "@/components/reader-home/types";
import ArticleCard from "@/components/journalist-profile/shared/ArticleCard";

interface ForYouSectionProps {
  articles: Article[];
}

const ForYouSection: React.FC<ForYouSectionProps> = ({ articles }) => {
  const navigate = useNavigate();
  
  return (
    <section className="mt-12">
      <h2 className="text-xl font-bold mb-6">For You</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {articles.slice(0, 2).map(article => (
          <ArticleCard 
            key={article.id} 
            layout="horizontal"
            article={{
              ...article,
              category: article.topics?.[0] || 'Recommended',
              author_name: article.author,
              author_avatar: article.author_avatar,
              excerpt: article.excerpt,
              premium: false,
              featured: false,
              readTime: typeof article.readTime === 'string' ? 
                parseInt(article.readTime.replace('min read', '').trim()) : 
                article.readTime || 3
            }} 
          />
        ))}
      </div>
    </section>
  );
};

export default ForYouSection;
